import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export interface EventWizardDateTimeModalProps {
  // add props here
}

export const openEventWizardDateTimeModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EVENT_WIZARD_DATE_TIME_MODAL,
      panelProps: {},
    })
  );
};
